import { useFormContext, useWatch } from "react-hook-form";
import { Grid } from "@mui/material";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { studentRequests } from "api/studentApi";
import { administrationRequests } from "api/administrationApi";

const AcademicSessionIdFilterBlock = ({ hasSavedFilters }) => {
  const { setValue } = useFormContext();

  const academicYearId = useWatch({ name: "academicYearId" });
  const instructionLanguageId = useWatch({ name: "instructionLanguageId" });
  const studyTypeId = useWatch({ name: "studyTypeId" });

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        sm={6}
        md={3}
      >
        <ReferenceInput
          source="academicYearId"
          reference={studentRequests.getAcademicYearsSelect()}
        >
          <SelectInput
            label="Академична година"
            validate={required()}
            readOnly={hasSavedFilters}
            onChange={() => {
              setValue("structuralUnitId", null);
              setValue("instructionLanguageId", null);
              setValue("studyTypeId", null);
              setValue("academicSessionId", null);
            }}
          />
        </ReferenceInput>
      </Grid>
      {academicYearId && (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
        >
          <ReferenceInput
            source="instructionLanguageId"
            reference={administrationRequests.getInstructionLanguagesSelect()}
          >
            <SelectInput
              label="Език на обучение"
              validate={required()}
              readOnly={hasSavedFilters}
              onChange={() => {
                setValue("studyTypeId", null);
                setValue("academicSessionId", null);
              }}
            />
          </ReferenceInput>
        </Grid>
      )}
      {instructionLanguageId && (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
        >
          <ReferenceInput
            source="studyTypeId"
            label="Вид на обучение"
            reference={administrationRequests.getStudyTypesSelect()}
          >
            <SelectInput
              optionText="name"
              label="Вид на обучение"
              validate={required()}
              readOnly={hasSavedFilters}
              emptyText={false}
              fullWidth
              onChange={() => {
                setValue("academicSessionId", null);
              }}
            />
          </ReferenceInput>
        </Grid>
      )}

      {studyTypeId && (
        <Grid
          item
          md={3}
          sm={6}
          xs={12}
        >
          <ReferenceInput
            source="academicSessionId"
            reference={studentRequests.getAcademicSessionsSelect()}
            filter={{ onlySemesters: true, academicYearId, instructionLanguageId, studyTypeId }}
          >
            <SelectInput
              label="Семестър"
              optionText="sessionTypeText"
              emptyText={false}
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
      )}
    </Grid>
  );
};

export default AcademicSessionIdFilterBlock;
